import React from 'react'
import {Link} from "react-router-dom";
import '../css/main_style.css';
import Toppart from '../pages/toppart'
import MenuBar from '../pages/Menu'
import HomeContent from '../pages/financialsContent'
import Footer from '../pages/Footer'
import Schedules from '../pages/homenotices'

export default function Home() {
	return(<div>
		<div id="maincontainer">	
			<Toppart />
			<MenuBar />
			<Schedules />
			<HomeContent />
			<Footer />	
		</div>	
					
	</div>)
}

	